import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface PeriodSelectorProps {
  selectedPeriod: string;
  onPeriodChange: (value: string) => void;
}

export const PeriodSelector = ({ selectedPeriod, onPeriodChange }: PeriodSelectorProps) => {
  return (
    <Select value={selectedPeriod} onValueChange={onPeriodChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Sélectionner une période" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="day">Jour</SelectItem>
        <SelectItem value="week">Semaine</SelectItem>
        <SelectItem value="month">Mois</SelectItem>
        <SelectItem value="year">Année</SelectItem>
      </SelectContent>
    </Select>
  );
};